"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayCustomerLogoById = exports.getSrcForImg = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const ArgusUtils = tslib_1.__importStar(require("@mnemonic/pure-utils/ArgusUtils"));
const sizes = {
    small: { width: 150, height: 24 },
    medium: { width: 200, height: 32 },
    large: { width: 250, height: 40 },
    xlarge: { width: 400, height: 64 },
};
const DEFAULT_SIZE = "small";
/**
 * Generates a URL for fetching a customer logo with optional query parameters.
 *
 * @param {Object} params - Parameters for generating the URL.
 * @param {IDisplayCustomerLogoByIdProps["criteria"]} params.criteria - Criteria for the customer logo.
 * @param {boolean} params.bypassCache - Flag to indicate if cache should be bypassed.
 * @returns {string} - The constructed URL for the customer logo.
 */
const getSrcForImg = (options) => {
    const apiUrl = `${ArgusUtils.getApiUrl()}/customers/v2/customer/${options.criteria.idOrShortName}/logo`;
    const params = new URLSearchParams();
    if (options.criteria.includeDefault !== undefined) {
        params.append("includeDefault", String(options.criteria.includeDefault));
    }
    if (options?.criteria?.domain) {
        params?.append("domain", options?.criteria?.domain);
    }
    if (options?.bypassCache) {
        params.append("_", new Date().getTime().toString());
    }
    return `${apiUrl}?${params.toString()}`;
};
exports.getSrcForImg = getSrcForImg;
/**
 * Displays a customer logo by ID or short name.
 *
 * @component
 * @param {IDisplayCustomerLogoByIdProps} props - Props for DisplayCustomerLogoById component.
 * @returns {React.ReactElement} - A React component displaying the customer logo.
 */
const DisplayCustomerLogoById = ({ bypassCache = false, criteria, size, ...restProps }) => {
    const [errorLoading, setErrorLoading] = (0, react_1.useState)(false);
    const dimensions = sizes[size || DEFAULT_SIZE];
    const handleImageError = () => {
        setErrorLoading(true);
    };
    const imageStyle = errorLoading
        ? { backgroundColor: "lightgray", display: "block" }
        : { height: `${dimensions.height}px`, maxWidth: `${dimensions.width}px` };
    return (react_1.default.createElement("img", { onError: handleImageError, src: (0, exports.getSrcForImg)({ criteria, bypassCache }), style: imageStyle, ...restProps }));
};
exports.DisplayCustomerLogoById = DisplayCustomerLogoById;
